module.exports = __webpack_public_path__ + "static/media/GG_A_08.4b43d829.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/accessorius/GG_A_08.png
// module id = 192
// module chunks = 0